<div class="page">

  <div class="page-header">
    <div>
      <h1>News</h1>
      <p>Manage real-estate news and announcements</p>
    </div>
    <button class="btn-primary" (click)="goToNew()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
      </svg>
      New Article
    </button>
  </div>

  <div class="filter-bar">
    <button class="filter-btn" [class.active]="activeFilter === 'all'" (click)="setFilter('all')">All</button>
    <button class="filter-btn" [class.active]="activeFilter === 'active'" (click)="setFilter('active')">Active</button>
    <button class="filter-btn" [class.active]="activeFilter === 'inactive'" (click)="setFilter('inactive')">Inactive</button>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading news...</p>
  </div>

  <div class="news-grid" *ngIf="!isLoading">

    <div class="news-card" *ngFor="let item of newsList" (click)="goToDetail(item.id)">

      <!-- Media Preview -->
      <div class="card-media">
        <ng-container *ngIf="item.media && item.media.length > 0; else noMedia">
          <video *ngIf="isVideo(item.media[0])" [src]="item.media[0]" class="media-preview"></video>
          <img *ngIf="!isVideo(item.media[0])" [src]="item.media[0]" [alt]="item.title" class="media-preview" />
        </ng-container>
        <ng-template #noMedia>
          <div class="media-placeholder">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
              <polyline points="21 15 16 10 5 21"/>
            </svg>
          </div>
        </ng-template>
        <span class="media-count" *ngIf="item.media && item.media.length > 1">
          +{{ item.media.length - 1 }} more
        </span>
      </div>

      <!-- Card Body -->
      <div class="card-body">
        <div class="card-top">
          <span class="badge" [class.badge-active]="item.is_active" [class.badge-inactive]="!item.is_active">
            {{ item.is_active ? 'Active' : 'Inactive' }}
          </span>
          <span class="card-date">{{ item.published_at | date:'mediumDate' }}</span>
        </div>
        <h3 class="card-title">{{ item.title }}</h3>
        <p class="card-content">{{ item.content }}</p>
        <div class="card-footer">
          <span class="card-author">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
            {{ item.published_by || '—' }}
          </span>
        </div>
      </div>

    </div>

    <div class="empty-state" *ngIf="newsList.length === 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
      </svg>
      <p>No news articles yet.</p>
      <button class="btn-primary" (click)="goToNew()">Create First Article</button>
    </div>

  </div>

</div>
